<template>
  <div v-click-outside="onClickOutside" id="box--languages">
    <span class="submenu--item" @click="openLanguages()">
      Language
      <font-awesome-icon class="submenu--icon" icon="chevron-down" />
    </span>
    <div class="box--languages">
      <div class="box--languages--triangulo"></div>
      <span class=""></span>
      <span class="box--reset" @click="closeLanguages()">X Reset</span>

      <template v-for="g in items">
        <span
          :key="g.id"
          class="box--item"
          :id="g.id"
          @click="selectLanguage(g)"
          ><font-awesome-icon class="box--icon" icon="check" />
          {{ g.name }}</span
        >
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    items: [
      { id: 1, name: "English", order: 1 },
      { id: 2, name: "Spanish", order: 2 },
      { id: 3, name: "Hindi", order: 3 },
      { id: 4, name: "Telugu", order: 4 },
      { id: 5, name: "Tamil", order: 5 },
      { id: 6, name: "Malayalam", order: 6 },
      { id: 7, name: "Kannada", order: 7 },
      { id: 8, name: "Bengali", order: 8 },
      { id: 9, name: "Bhojpuri", order: 9 },
      { id: 10, name: "Gujarati", order: 10 },
      { id: 11, name: "Marathi", order: 11 },
      { id: 12, name: "Punjabi", order: 12 },
      { id: 13, name: "Korean", order: 13 },
      { id: 14, name: "Chinese", order: 14 },
      { id: 15, name: "Foreign (Other)", order: 15 },
    ],
    languages: [],
  }),
  computed: mapState(["paramsMust"]),

  created() {
    this.closeLanguages();
    if (this.$route.name != "MustWatch")
      this.$Parse.Cloud.run("getLanguages")
        .then((res) => {
          this.items = res;
        })
        .catch((error) => {
          console.log(error);
        });
    this.languages = this.paramsMust.language;
    setTimeout(() => {
      this.checkLangueges();
    }, 2000);
  },
  mounted() {},
  methods: {
    onClickOutside() {
      let el = document.getElementsByClassName("box--languages");
      el[0].classList.remove("menu-visible");
    },

    openLanguages() {
      let el = document.getElementsByClassName("box--languages");
      el[0].classList.toggle("menu-visible");
    },
    closeLanguages() {
      this.languages = [];
      let params = {
        data: "",
        src: this.$route.name,
      };
      this.$store.dispatch("FETCH_EDIT_LANGUAGE", params);
      let item = document.getElementsByClassName("box--item");
      item.forEach((element) => {
        let icon = element.children[0];
        element.classList.remove("language-active");
        icon.classList.remove("language-active-icon");
      });
    },
    checkLangueges() {
      const id = this.items.findIndex(
        (element) => element.name === this.languages
      );
      if (id != -1) {
        let item = document.getElementById(this.items[id].id);
        let icon = item.children[0];
        item.classList.toggle("language-active");
        icon.classList.toggle("language-active-icon");
      }
    },
    selectLanguage(i) {
      let item = document.getElementsByClassName("box--item");
      item.forEach((element) => {
        let icon = element.children[0];
        element.classList.remove("language-active");
        icon.classList.remove("language-active-icon");
      });

      let select = document.getElementById(i.id);
      let icon = select.children[0];
      select.classList.toggle("language-active");
      icon.classList.toggle("language-active-icon");

      let params = {
        data: i.name,
        src: this.$route.name,
      };
      this.$store.dispatch("FETCH_EDIT_LANGUAGE", params);
      this.onClickOutside();
    },
  },
};
</script>

<style scoped>
.box--languages {
  background-color: #1c2531;
  display: grid;
  grid-template-columns: repeat(2, 180px);
  column-gap: 25px;
  color: #d5d5d5;
  font-size: 0.8em;
  padding: 4px 20px 15px 20px;
  position: absolute;
  z-index: 9000;
  margin-top: 10px;
  margin-left: -50px;
  visibility: hidden;
}
.submenu--item {
  color: #d5d5d5;
  font-size: 15px;
  cursor: pointer;
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
}
.submenu--icon {
  font-weight: thin;
  padding-left: 10px;
  align-self: end;
}

.box--languages--triangulo {
  position: absolute;
  width: 20px;
  height: 10px;
  top: -8px;
  left: 50px;
  background: #1c2531;

  /* The points are: centered top, left bottom, right bottom */
  clip-path: polygon(50% 0, 0 100%, 100% 100%);
}

.box--title {
  color: white;
  font-size: 1.3em;
  padding-bottom: 10px;
}
.box--reset {
  align-self: top;
  justify-self: end;
  cursor: pointer;
}

.box--item {
  padding: 5px;
  margin: 2px;
  cursor: pointer;
}

.box--icon {
  padding-right: 5px;
}

.language-active {
  color: white;
  font-weight: 600;
  border: 1px solid #738092;
  border-radius: 7px;
}
.language-active-icon {
  color: #94c659;
}
.menu-visible {
  visibility: visible;
}

@media (min-width: 600px) and (max-width: 960px) {
  .submenu--item {
    font-size: 0.75em;
  }
  .menu--item-select {
    align-self: end;
    column-gap: 0px;
  }
}
@media (max-width: 600px) {
  .submenu--item {
    font-size: 0.5em;
  }
  .box--languages {
    width: 80vw;
    margin: 0;
    grid-template-columns: repeat(2, auto);
    column-gap: 15px;
    left: 0;
    right: 0;
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
  }
  .box--languages--triangulo {
    visibility: hidden;
  }
}
</style>
